'use client';

import React from 'react';

import { default as CircularProgress } from '@mui/material/CircularProgress';

import { useOngoingContests } from '@/api/contests/useContests';
import { CardsSlider } from '@/blocks/components/CardsSlider';
import { Container } from '@/blocks/components/Container';

import { TradingContestsOngoingCard } from '../TradingContestsOngoingCard';
import styles from './TradingContestsOngoingSlider.module.scss';

export const TradingContestsOngoingSlider = () => {
  const { cards, isLoading } = useOngoingContests();

  if (isLoading || !cards?.length) {
    return (
      <div className={styles.placeholder}>
        <CircularProgress size={32} sx={{ color: 'var(--palette-gray-400)' }} />
      </div>
    );
  }

  if (cards?.length <= 3) {
    return (
      <div>
        <Container>
          <div className={styles.cardsGrid}>
            {cards.map((card) => (
              <TradingContestsOngoingCard key={card.id} {...card} />
            ))}
          </div>
        </Container>
      </div>
    );
  }

  return (
    <CardsSlider
      items={cards}
      renderCard={(card) => <TradingContestsOngoingCard {...card} />}
      itemKey={'id'}
      classes={{ slide: styles.slide }}
    />
  );
};
